<template>
  <validation-provider :rules="rules" :name="`${tab}.${field}`" v-slot="{ valid, errors, changed }" :class="className" class="col">
    <b-form-radio-group
      :state="onValidateField(valid, errors, changed)"
      stacked
      @change="updateField"
      v-model="localField"
    >
      <b-button :id="`${tab}.${field}`" v-if="helpText" class="help-icon">?</b-button>
      <b-popover v-if="helpText" :target="`${tab}.${field}`" triggers="hover" placement="top">
        <template v-slot:title>Info</template>
        {{helpText}}
      </b-popover>

      <template v-if="isBooleanField">
        <b-form-radio :value="true">Ja</b-form-radio>
        <b-form-radio :value="false">Nein</b-form-radio>
      </template>
      <template v-else>
        <b-radio
          v-for="radioValue in defaultValues"
          :value="radioValue.value"
          :key="radioValue.value"
        >
          {{ radioValue.text }}
        </b-radio>
      </template>
    </b-form-radio-group>
    <b-form-invalid-feedback id="inputLiveFeedback">{{ errors[0] }}</b-form-invalid-feedback>
  </validation-provider>
</template>

<script>
  import { ValidationProvider } from 'vee-validate'
  import { mapState } from 'vuex'
  import { validateField } from '@/helpers/formHelper.js'

  export default {
    components: {
      ValidationProvider
    },
    props: {
      tab: {
        type: String,
        required: true
      },
      helpText: String,
      field: {
        type: String,
        required: true
      },
      defaultValues: {
        type: [String, Array, Boolean]
      },
      placeholder: String,
      className: String,
      rules: String,
      isBooleanField: Boolean,
      appendText: String
    },
    data: () => ({
      localField: ''
    }),
    created () {
      this.localField = this.getField
    },
    computed: mapState({
      getField (state) {
        const { tab, field } = this
        return state.application.createApplication.formData[tab][field]
      }
    }),
    methods: {
      updateField (value) {
        const { tab, field } = this
        this.$store.commit('application/SET_FORMFIELD_VALUE', {
          tab,
          field,
          value
        })
      },
      onValidateField (valid, errors, changed) {
        return validateField(valid, errors, changed)
      }
    }
  }
</script>
